import CfdTable from './CfdTable';

export default CfdTable;
